import { createSelector } from "reselect";

const tiposContenidoReducerSelector = (state) => state.contenidoReducer.getIn(["data"]).toJS();
export const tiposContenidoSelector = createSelector(tiposContenidoReducerSelector, (dataField) => {
  return dataField;
});
